import { Component } from "react";
import Headerdash from "../components/headerdash";
import SunEditor, { buttonList } from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';

export default class Aboutedit extends Component {
    constructor(props)
    {
        super(props);
        this.state = {
            aboutcontent: [{title: 'Loading', content: 'loading'}],
            loaded: false
        }
    }

    removesection = (i) => {
        let ac = [...this.state.aboutcontent];
        ac.splice(i, 1);
        this.setState({
            aboutcontent: ac
        });
    }

    updatetitle = (i, val) => {
        let ac = [...this.state.aboutcontent];
        ac[i].title = val;
        ac[i] = {...ac[i], title: val};
        this.setState({
            aboutcontent: ac
        });
    }

    updatecontent = (i, val) => {
        console.log(val);
        let ac = [...this.state.aboutcontent];
        ac[i].content = val;
        ac[i] = {...ac[i], content: val};
        this.setState({
            aboutcontent: ac
        });
        return val;
    }

    saveabout = () => {
        let ac = JSON.stringify(this.state.aboutcontent);
        fetch('https://api.voicecoach.net/update-about', {credentials: 'include', headers: {'Content-type':'application/json'}, body: ac, method: 'post'})
        .then(res => { if (res.status === 401) { window.location.href = '/login' } return res.json()})
        .then(sj => window.open('/about'));
    }

    componentDidMount()
    {
        fetch('https://api.voicecoach.net/view-about', {credentials: 'include'})
        .then(res => res.json())
        .then(jr => { this.setState({ aboutcontent: jr, loaded: true});});
    }

    addSection = () => {
        let news = [...this.state.aboutcontent];
        news.push({title: '', content: ''});
        this.setState({
            aboutcontent: news
        });
    }

    render() {
        let ac = "loading...";
        if (this.state.loaded) {
            ac = this.state.aboutcontent;
            ac = ac.map((c,i) => <><div className="row my-2" key={i}><div className="col-8 mx-auto position-relative"><div className="closesection btn btn-danger position-absolute end-0" onClick={() => { this.removesection(i); }}>x</div>
                <input type="text" className="heading form-control" value={c.title} onChange={(elem) => {this.updatetitle(i, elem.target.value)}} />
                <SunEditor
                    setOptions={{ height: 200, buttonList: buttonList.complex }}
                    setContents= { c.content }
                    onChange = {(c) => {
                        this.updatecontent(i, c)
                    }}
                />
                </div></div></>)
        }
        return <>
        <Headerdash />
        <section className="container mt-3">
            {ac}
            <div className="row position-relative">
            <div className="btn btn-primary position-absolute end-0 col-1" onClick={this.addSection}>+ Add more section</div>
        </div>
           <button className="mt-3 btn btn-primary btn-lg" onClick={this.saveabout}>Done? Click this to save</button>
        </section>
        </>
    }
}